import { GET__HIGEST_POLL, LOADING__HIGEST_POLL, ERR__HIGEST_POLL,GET_POLL_ANALYSIS,POLL_RESULT_CLEAR, LOADING__POLL_ANALYSIS, ERR__GET__POLL_ANALYSIS } from "../actions/actionTypes";

const initialState = {
    highest_poll:null,
    loading: false,
    err: false,
    msg: "",
    stats:null,
    poll_analysis:null,
};

export default function reporting_dashboardReducer(state = initialState, { type, payload }) { 
       console.log("reporting_dashboardReducer payload", payload);
       
    switch (type) {
        case GET__HIGEST_POLL:
            return {
                ...state,
                highest_poll: payload?.data?.data[0],
                loading: false,
                msg: payload?.data?.message
            }

        case LOADING__HIGEST_POLL:
            return {
                ...state,
                loading: true,
            }
        
        case ERR__HIGEST_POLL:
            return {
                ...state,
                loading: false,
                err: true,
                msg: payload,
            }
        case GET_POLL_ANALYSIS:
            return {
                ...state,
                stats: payload?.data?.data?.count,
                poll_analysis: payload?.data?.data,
                loading: false,
                msg: payload?.data?.message
            }

        case LOADING__POLL_ANALYSIS:
            return {
                ...state,
                loading: true,
            }
        case ERR__GET__POLL_ANALYSIS:
            return {
                ...state,
                loading: false,
                err: true,
                msg: payload,
            }
        case POLL_RESULT_CLEAR:
            return {
                ...state,
                poll_analysis: null,
                stats: null,
                
            }
    
        default:
            return state;
    }
}